export default __webpack_public_path__ + "static/light_bulb_b.9201ebe939d9485236a1a8508f350b7b.png";